import { WidgetSchema } from '@/entities/widget';

export function sortByIdOrder(
  order: string[],
  items: WidgetSchema[],
): WidgetSchema[] {
  const indexMap = new Map(order.map((id, idx) => [id, idx]));
  return [...items].sort((a, b) => {
    return (indexMap.get(a.id) ?? Infinity) - (indexMap.get(b.id) ?? Infinity);
  });
}
